export default "__VITE_ASSET__DaI1vIjr__"